import '../styles/popup.scss';
import { useState, useEffect } from 'react';

export const PopUpMessage = () => {
  const [ popUp, setPopUp ]  = useState(false);

  useEffect(() => {
    setTimeout(
      () => setPopUp(true),
      5000
    )
  }, []);

  const close = () => setPopUp(false);
 
  return (
    <>
      {popUp ? 
        <div className='pop-up'>
          <div className='pop-up-box'>
            <div className='img-pop-up'></div>
            <div className='content-pop-up'>
              <div className='pop-up-btn'>
                <button onClick={close}>X</button>
              </div>
              <div className='text-pop-up'>
              <span>Valentine’s Day – February 14th</span>
<h3>Suit Up for Love</h3>
<span className='anexo'>
  This Valentine’s Day, make the night unforgettable. <br />
  Dress sharp with the perfect tuxedo for your special date.
</span>
              </div>
            </div>
          </div>
        </div> 
      : null}
    </>
  );
};
